var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"fill":_vm._secondaryfill}},[_c('path',{attrs:{"d":"M16,3.6L15.2,2C8.3,4,4.8,8.4,4.8,8.4L1.6,6L0,7.6L4.8,14C8.5,7.1,16,3.6,16,3.6z","fill":_vm.fill}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }